<template>
    <div>
        <div class="columns">
            <div class="column">
                <router-link to="/">
                    <img
                        src="../../assets/logo-saludosConsentidos.png"
                        alt="Logo coaniquem"
                        class="my-5 mx-6"
                    />
                </router-link>
            </div>
        </div>
        <div class="columns">
            <div class="column is-four-fifths ml-6">
                <h1 class="title is-size-5">Crea un saludo</h1>
                <div class="columns">
                    <div class="column is-half has-background-white">
                        <h2 class="subtitle is-size-6 has-text-weight-semibold">
                            Formulario para editar la categoria
                        </h2>
                        <form>
                            <b-field label="Nombre">
                                <b-input
                                    name="name"
                                    id="name"
                                    v-model="$v.data.name.$model"
                                ></b-input>
                            </b-field>
                            <div
                                class="error help mb-4"
                                v-if="!$v.data.name.required"
                            >
                                Este campo es obligatorio
                            </div>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.name.minLength"
                            >
                                El Titulo debe tener al menos
                                {{ $v.data.name.$params.minLength.min }}
                                caracteres.
                            </span>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.name.maxLength"
                            >
                                El Nombre debe tener como máximo
                                {{ $v.data.name.$params.maxLength.max }}
                                caracteres.
                            </span>
                            <b-field label="Descripción">
                                <b-input
                                    name="description"
                                    id="description"
                                    v-model="$v.data.description.$model"
                                ></b-input>
                            </b-field>
                            <div
                                class="error help mb-4"
                                v-if="!$v.data.description.required"
                            >
                                Este campo es obligatorio
                            </div>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.description.minLength"
                            >
                                La descripción debe tener al menos
                                {{ $v.data.description.$params.minLength.min }}
                                caracteres.
                            </span>
                            <b-field label="Label superior">
                                <b-input
                                    name="label1"
                                    id="label1"
                                    v-model="$v.data.label1.$model"
                                ></b-input>
                            </b-field>
                            <div
                                class="error help mb-4"
                                v-if="!$v.data.label1.required"
                            >
                                Este campo es obligatorio
                            </div>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.label1.minLength"
                            >
                                El Titulo debe tener al menos
                                {{ $v.data.label1.$params.minLength.min }}
                                caracteres.
                            </span>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.label1.maxLength"
                            >
                                El Nombre debe tener como máximo
                                {{ $v.data.label1.$params.maxLength.max }}
                                caracteres.
                            </span>
                            <b-field label="Segundo Label">
                                <b-input
                                    name="label2"
                                    id="label2"
                                    v-model="$v.data.label2.$model"
                                ></b-input>
                            </b-field>
                            <div
                                class="error help mb-4"
                                v-if="!$v.data.label2.required"
                            >
                                Este campo es obligatorio
                            </div>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.label2.minLength"
                            >
                                El Titulo debe tener al menos
                                {{ $v.data.label2.$params.minLength.min }}
                                caracteres.
                            </span>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.label2.maxLength"
                            >
                                El Nombre debe tener como máximo
                                {{ $v.data.label2.$params.maxLength.max }}
                                caracteres.
                            </span>
                            <b-field label="Label inferior">
                                <b-input
                                    name="label3"
                                    id="label3"
                                    v-model="$v.data.label3.$model"
                                ></b-input>
                            </b-field>
                            <div
                                class="error help mb-4"
                                v-if="!$v.data.label3.required"
                            >
                                Este campo es obligatorio
                            </div>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.label3.minLength"
                            >
                                El Titulo debe tener al menos
                                {{ $v.data.label3.$params.minLength.min }}
                                caracteres.
                            </span>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.label3.maxLength"
                            >
                                El Nombre debe tener como máximo
                                {{ $v.data.label3.$params.maxLength.max }}
                                caracteres.
                            </span>
                            <b-field label="Mensaje 1">
                                <b-input
                                    type="textarea"
                                    name="message_0"
                                    id="message_0"
                                    v-model="$v.data.message_0.$model"
                                ></b-input>
                            </b-field>
                            <div
                                class="error help mb-4"
                                v-if="!$v.data.message_0.required"
                            >
                                Este campo es obligatorio
                            </div>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.message_0.minLength"
                            >
                                El Titulo debe tener al menos
                                {{ $v.data.message_0.$params.minLength.min }}
                                caracteres.
                            </span>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.message_0.maxLength"
                            >
                                El Nombre debe tener como máximo
                                {{ $v.data.message_0.$params.maxLength.max }}
                                caracteres.
                            </span>
                            <b-field label="Mensaje 2">
                                <b-input
                                    type="textarea"
                                    name="message_1"
                                    id="message_1"
                                    v-model="$v.data.message_1.$model"
                                ></b-input>
                            </b-field>

                            <div
                                class="error help mb-4"
                                v-if="!$v.data.message_1.required"
                            >
                                Este campo es obligatorio
                            </div>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.message_1.minLength"
                            >
                                El Titulo debe tener al menos
                                {{ $v.data.message_1.$params.minLength.min }}
                                caracteres.
                            </span>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.message_1.maxLength"
                            >
                                El Nombre debe tener como máximo
                                {{ $v.data.message_1.$params.maxLength.max }}
                                caracteres.
                            </span>
                            <b-field label="Mensaje 3">
                                <b-input
                                    type="textarea"
                                    name="message_2"
                                    id="message_2"
                                    v-model="$v.data.message_2.$model"
                                ></b-input>
                            </b-field>
                            <div
                                class="error help mb-4"
                                v-if="!$v.data.message_2.required"
                            >
                                Este campo es obligatorio
                            </div>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.message_2.minLength"
                            >
                                El Titulo debe tener al menos
                                {{ $v.data.message_2.$params.minLength.min }}
                                caracteres.
                            </span>
                            <span
                                class="error help mb-4 has-text-danger"
                                v-if="!$v.data.message_2.maxLength"
                            >
                                El Nombre debe tener como máximo
                                {{ $v.data.message_2.$params.maxLength.max }}
                                caracteres.
                            </span>

                            <b-button type="is-danger" @click="sendData()"
                                >Modificar</b-button
                            >
                        </form>
                    </div>
                    <div class="column ml-6">
                        <h3 class="title is-size-5">Ejemplo</h3>
                        <img
                            src="../../assets/ejemploLabels.png"
                            alt="simple ejemplo"
                        />
                    </div>
                </div>
            </div>
        </div>
        <theLoader v-show="loadingStatus" />
    </div>
</template>
<script>
import { UrlCategory } from '../../Url'
import theLoader from '../common/theLoader'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
    components: {
        theLoader,
    },
    data() {
        return {
            data: {
                name: '',
                description: '',
                label1: '',
                label2: '',
                label3: '',
                message_0: '',
                message_1: '',
                message_2: '',
            },
            categoryEditable: [],
            loadingStatus: false,
        }
    },
    validations: {
        data: {
            name: {
                required,
                maxLength: maxLength(25),
                minLength: minLength(4),
            },
            label1: {
                required,
                maxLength: maxLength(50),
                minLength: minLength(4),
            },
            label2: {
                required,
                maxLength: maxLength(50),
                minLength: minLength(4),
            },
            label3: {
                required,
                maxLength: maxLength(50),
                minLength: minLength(4),
            },
            message_0: {
                required,
                maxLength: maxLength(250),
                minLength: minLength(4),
            },
            message_1: {
                required,
                maxLength: maxLength(250),
                minLength: minLength(4),
            },
            message_2: {
                required,
                maxLength: maxLength(250),
                minLength: minLength(4),
            },
            description: {
                required,
                minLength: minLength(5),
            },
        },
    },
    methods: {
        sendData() {
            const vm = this
            if (this.$v.$invalid) {
                this.$buefy.dialog.alert({
                    message:
                        '¡Ups! Aún queda información por validar. Por favor revise los datos ingresados y envíe el formulario nuevamente.',
                    confirmText: 'Entendido',
                })
            } else {
                const {
                    name,
                    description,
                    label1,
                    label2,
                    label3,
                    message_0,
                    message_1,
                    message_2,
                } = this.data
                const label = `${label1}||${label2}|${label3}`
                const payload = {
                    name,
                    description,
                    label,
                    message_0,
                    message_1,
                    message_2,
                }
                this.loadingStatus = true
                let token = JSON.parse(
                    sessionStorage.getItem('vue-session-key')
                )
                fetch(`${UrlCategory}/10`, {
                    method: 'PUT',
                    body: JSON.stringify(payload),
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + token.jwt,
                    },
                })
                    .then((res) => res.json())
                    .then(function (msg) {
                        vm.loadingStatus = false
                        if (msg.error) {
                            vm.$buefy.dialog.alert({
                                title: 'Error',
                                message:
                                    'Ha ocurrido un error, recuerde que ningún campo puede quedar vacío',
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true,
                            })
                        } else {
                            vm.$buefy.dialog.alert({
                                title: 'Modificación completada',
                                message: `${msg.data}`,
                                type: 'is-success',
                                hasIcon: true,
                                icon: 'thumbs-up',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true,
                            })
                            vm.data = {}
                        }
                    })
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.bg-create {
    background-color: #fafafa;
}
</style>
